//import './fa.config';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueCarousel from 'vue-carousel';


import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
// Add all icons to the library so you can use it in your page
library.add(fas, far, fab)

import BootstrapVue from 'bootstrap-vue'
import vuetify from './plugins/vuetify';

Vue.use(BootstrapVue)

Vue.component('font-awesome-icon', FontAwesomeIcon); // registered globally

Vue.use(VueCarousel);

const app = new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')

// Step 2: Create a renderer
/*const renderer = require('vue-server-renderer').createRenderer()

// Step 3: Render the Vue instance to HTML
renderer.renderToString(app, (err, html) =>
{
  if (err) throw err
  console.log(html)
  // => <div data-server-rendered="true">Hello World</div>
})*/